import Thing from './Thing'

/**
 * Defines a person (alive, dead, undead, or fictional).
 * @memberOf things
 */
class Person extends Thing
{
    /**
     * Creates a new Person instance.
     * @constructor
     * @param object The generic object to initialize the object the first time.
     * @param lock Optional flag to lock the clear process.
     */
    constructor( object = null )
    {
        super() ;

        /**
         * Physical address of the item.
         * @type {Object|string}
         */
        this.address = null ;

        /**
         * Email address.
         * @type {Object|string}
         */
        this.email = null ;

        /**
         * Family name. In the U.S., the last name of an Person. This can be used along with givenName instead of the name property.
         * @type {string}
         */
        this.familyName = null ;

        /**
         * Gender of the person
         * @type {Object|string}
         */
        this.gender = null ;

        /**
         * Given name. In the U.S., the first name of a Person. This can be used along with familyName instead of the name property.
         * @type {string}
         */
        this.givenName = null ;

        this.set( object ) ;
    }


    /**
     * Clear the object.
     * @return {Object} The current item reference.
     */
    clear()
    {
        super.clear() ;
        this.address    = null ;
        this.email      = null ;
        this.familyName = null ;
        this.gender     = null ;
        this.givenName  = null ;
        return this ;
    }

    /**
     * Returns a shallow copy of the object.
     * @return {Thing} a shallow copy of the object.
     */
    clone()
    {
        return new Person( this.toObject() ) ;
    }

    /**
     * Generates the fullname of the person (givenName + familyName) or returns the alternateName or the name value.
     * @returns {string}
     */
    getFullNameOrUsername()
    {
        let name = [] ;

        if( ( (this.givenName instanceof String) || typeof(this.givenName) === 'string') )
        {
            name.push( this.givenName ) ;
        }

        if( ( (this.familyName instanceof String) || typeof(this.familyName) === 'string') )
        {
            name.push( this.familyName ) ;
        }

        if( (name.length === 0) )
        {
            if(  this.alternateName )
            {
                name.push(this.alternateName);
            }
            else if ( this.name )
            {
                name.push( this.name ) ;
            }
        }

        return name.join(' ') ;
    }

    /**
     * Returns the generic object representation of the item.
     * @return {Object} The generic object representation of the item.
     */
    toObject()
    {
        return { ...super.toObject() , ...{
            address    : this.address,
            email      : this.email,
            familyName : this.familyName,
            gender     : this.gender,
            givenName  : this.givenName
        }}
    }
}

export default Person ;


// WEBPACK FOOTER //
// ./src/app/things/Person.js